import { useEffect, useRef, useState } from "react";
import { subscribe, unsubscribe } from "../../utils/events";
import { formatRelativeDate } from "../../utils/date";

export function SegmentTooltip({ timelineContainerRef, ...props }) {
   const [hoveredSegment, setHoveredSegment] = useState();
   const ref = useRef();

   function updateSegment(data) {
      if (data !== null) {
         const { data: segmentData, el: targetEl } = data;
         if (hoveredSegment?.id === segmentData.id) {
            return;
         }
         const rect = targetEl.getBoundingClientRect();
         const hSegment = {
            duration: formatRelativeDate(segmentData.startDate, segmentData.endDate, { simple: true, minDays: false, onlyValue: true }),
            startDate: new Date(segmentData.startDate),
            endDate: new Date(segmentData.endDate),
            x: rect.left + rect.width / 2,
            y: rect.bottom + 5,
         };
         if ('connection' in segmentData) {
            hSegment.value = segmentData.connection === 'connected' ? 'Online' : 'Offline';
            hSegment.color = segmentData.connection === 'connected' ? `var(--onlineColor)` : `var(--offlineColor)`;
         }
         if ('state' in segmentData) {
            hSegment.value = segmentData.state === 'open' ? 'Aberto' : 'Fechado';
            hSegment.color = segmentData.state === 'open' ? `var(--onlineColor)` : `var(--offlineColor)`;
         }

         ref.current?.style.setProperty('--segLeft', `${hoveredSegment.x}px`);
         setHoveredSegment(hSegment);
         return;
      }
      setHoveredSegment(null);
   }

   useEffect(() => {
      if (!ref.current || !timelineContainerRef.current) return;
      const targetEl = timelineContainerRef.current;
      const onMouseMove = (e) => {
         ref.current?.style?.setProperty(`--segLeft`, `${e.clientX}px`);
      };
      targetEl.addEventListener(`mousemove`, onMouseMove);
      return () => targetEl.removeEventListener(`mousemove`, onMouseMove);
   }, [
      ref.current,
      timelineContainerRef.current
   ]);

   useEffect(() => {
      subscribe(`segmentHover`, updateSegment);
      return () => unsubscribe(`segmentHover`, updateSegment);
   });

   return (
      <>
         {hoveredSegment && (
            <div
               ref={ref}
               className="fixed! pointer-events-none! top-(--segTop) left-(--segLeft) -translate-x-1/2 text-(--textColor) text-xs flex flex-col gap-[2px] z-90 bg-(--bodyBackgroundColor) shadow-lg rounded-lg p-2.5! border! border-(--borderColor)! box-border!"
               style={{
                  '--segTop': `${hoveredSegment.y}px`,
                  '--segColor': `${hoveredSegment.color}`,
               }}
            >
               <span className="font-extrabold! text-(--segColor) block mb-0.5!">
                  {hoveredSegment.value}
               </span>
               <span><span className="opacity-75">Duração:</span> {hoveredSegment.duration}</span>
               <span><span className="opacity-75">Início:</span> {hoveredSegment.startDate.toLocaleTimeString()}</span>
               <span><span className="opacity-75">Fim:</span> {hoveredSegment.endDate.toLocaleTimeString()}</span>
            </div>
         )}
      </>
   );
}
